import React, { useEffect, useState } from 'react';
import 'react-tabs/style/react-tabs.css'; 
import TextField from '@mui/material/TextField'; 
import { Alert } from "@mui/material";  
import Typography from '@mui/material/Typography'; 

import oscarIcon from '../../assets/images/icon/OSCAR_LOGO.png' 
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'; 
import StakeInfo from './stakeInfo'; 

function beautifyNumber(number, maxFraction) {
    if (typeof number !== "number" && isNaN(Number(number))) {
        throw new Error("Input must be a valid number");
    }
    return Number(number).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxFraction
    });
}


const StakeForm = ({
    stake,
    stakeData,
    address,
    userData,
    HtmlTooltip,
    openConnectModal,
    errorMessage,
    setErrorMessage,
    stakeButton,
    unstake,
    claimButton,
    unstakeButton,
    claimReward 
}) => {
    const [amount, setAmount] = useState(0);
    const [hopeBalance, setHopeBalance] = useState(0.00);
    const [userHopeMarketValue, setUserHopeMarketValue] = useState(0.00);
    const [hopePrice, setHopePrice] = useState(0.95);
    const [dailyYield, setDailyYield] = useState(0);
    const [weeklyYield, setWeeklyYield] = useState(0);
    const [referrer, setReferrer] = useState("");
    const [open, setOpen] = useState(false);

    let theme;
    if (localStorage) {
        theme = localStorage.getItem("theme");
    }
 

    useEffect(() => {
        if (userData) {
            const marketValue = parseFloat(userData.hopeBalance * hopePrice).toFixed(2);
            setUserHopeMarketValue(marketValue);
            setHopeBalance(userData.hopeBalance);
        } else {
            setUserHopeMarketValue(0);
        }
    }, [userData]);

    useEffect(() => {
        if (stakeData) {
            handleSetWeeklyYield();
        }
    }, [stakeData]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (userData) {
            if (parseFloat(userData.stakeAllowance) >= amount) {
                setOpen(true);
            }
        }
        stake(amount, referrer);
    };


    const handleSetMaxAmount = () => {
        const maxAmount = hopeBalance > 0 ? hopeBalance : "";
        setAmount(maxAmount);
        handleSetDailyYield();
    }

    const handleSetAmount = (value) => {
        if (value.toString().length < 6) {
            setAmount(value);
            handleSetDailyYield();
        }
    };

    const handleSetWeeklyYield = () => {
        if (amount > 0) {
            const _weeklyYield = parseFloat(amount * stakeData.weeklyYield).toFixed(4)
            setWeeklyYield(_weeklyYield);
        } else {
            setWeeklyYield(stakeData.weeklyYield);
        }
    }

    const handleSetDailyYield = () => {
        if (amount > 0) {
            const _dailyYield = parseFloat(amount * stakeData.dailyYield).toFixed(4)
            setDailyYield(_dailyYield);
        } else {
            setDailyYield(0);
        }
    }

    const handleSetReferrer = (_value) => {
        setReferrer(_value);
    };




    return (
        <> 
            {userData && parseFloat(userData.stakedAmount) > 0 ? (
                <div className="wallet-main" style={{ maxWidth: 1000 }}>
                    {errorMessage.length > 0 && (
                        <Alert severity="error" style={{ marginBottom: 40 }}>
                            {errorMessage}
                        </Alert>
                    )}
                    <div className="wallet-body">
                        <div className="left" style={{ marginBottom: 10 }}>
                            <p>Staked Amount</p>

                            <div className="price">
                                <h6>{userData ? userData.stakedAmount : 0} </h6>
                                <div className="sale success">OSCAR</div>
                            </div>

                            <div style={{ marginTop: 10, marginBottom: 4 }}>
                                {hopeBalance > 0 && (
                                    <p> {userData ? userData.pendingReward : 0} Reward
                                        &nbsp;
                                        <HtmlTooltip
                                            title={
                                                <React.Fragment>
                                                    <Typography color="inherit">&nbsp;Stake Rewards &nbsp;</Typography>
                                                    <span>Stake rewards are calculated based on the amount you stake and the annual percentage yield (APY). Rewards are distributed continuously, allowing you to grow your holdings over time.</span>
                                                </React.Fragment>
                                            }
                                        >
                                            <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10 }} />
                                        </HtmlTooltip>
                                    </p>
                                )}

                                {stakeData && (
                                    <p> <strong style={{ color: "##119f24" }}>{beautifyNumber(dailyYield, 4)} OSCAR</strong>   Daily Yield
                                        &nbsp;
                                        <HtmlTooltip
                                            title={
                                                <React.Fragment>
                                                    <Typography color="inherit">&nbsp;Daily Yield&nbsp;</Typography>
                                                    <span>Estimated daily rewards based on your staked amount and current reward rate {stakeData.rewardRatePerEpoch}&nbsp;</span> <br />
                                                </React.Fragment>
                                            }
                                        >
                                            <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10 }} />
                                        </HtmlTooltip>
                                    </p>
                                )}
                            </div>



                        </div>
                        <div className="right">
                            <form action="/wallet"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                }}
                            >
                                  <div className="group-button">
                                <button
                                    type="submit"
                                    disabled={
                                        !stakeData || !userData ||
                                        (claimButton.toString() != 'CLAIM') ||
                                        (unstakeButton.toString() != 'UNSTAKE')
                                    }
                                    className="cancel btn-action-3"
                                    style={{
                                        width: '100%',
                                        maxWidth: '420px',
                                        padding: '10px',
                                        border: "1px solid #007BFF",
                                        backgroundColor: '#fff', 
                                        color: '#007BFF',
                                        cursor: 'pointer',
                                        marginRight: 150,
                                        marginTop: 40
                                    }}
                                    onClick={() => {
                                        claimReward();
                                    }}
                                >
                                    {claimButton == "CLAIM" ? `CLAIM ${userData.pendingReward}` : claimButton}
                                </button>

                                <button
                                    type="submit"
                                    disabled={
                                        !stakeData || !userData ||
                                        (unstakeButton.toString() != 'UNSTAKE') ||
                                        (claimButton.toString() != 'CLAIM')
                                    }
                                    className="btn-action"
                                    style={{
                                        width: '100%',
                                        maxWidth: '420px',
                                        padding: '10px',
                                        backgroundColor: '#007BFF',
                                        color: '#fff',
                                        cursor: 'pointer',
                                        marginRight: 150,
                                        marginTop: 18
                                    }}
                                    onClick={() => {
                                        unstake();
                                    }}
                                >
                                    {unstakeButton == "UNSTAKE" ? `UNSTAKE ${userData.unstakeAmount}` : unstakeButton}
                                </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )
            :
            (
            <div className="wallet-main" style={{ maxWidth: 1000 }}>
                {errorMessage.length > 0 && (
                    <Alert severity="error" style={{ marginBottom: 40 }}>
                        {errorMessage}
                    </Alert>
                )}
                <div className="wallet-body">
                    <div className="left" style={{ marginBottom: 10 }}>
                        <p>OSCAR Balance</p>

                        <div className="price">
                            <h6>{hopeBalance ? beautifyNumber(hopeBalance, 2) : "0.00"} </h6>
                            <div className="sale success" style={{backgroundColor: "#119f24"}}>OSCAR</div>
                        </div>
                        <div style={{ marginTop: 10, marginBottom: 4 }}>
                            {hopeBalance > 0 && (
                                <p>${beautifyNumber(userHopeMarketValue, 2)}
                                    &nbsp;
                                    <HtmlTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit">&nbsp;Market Value &nbsp;</Typography>
                                                <span>&nbsp;OSCAR Price: {hopePrice}&nbsp;</span> <br />
                                                <span>&nbsp;Est. Market Value: {userHopeMarketValue}&nbsp;</span> <br />
                                                <span>&nbsp;The estimated market value of your &nbsp;</span>
                                                <span>&nbsp;balance based on the current price&nbsp;</span>
                                            </React.Fragment>
                                        }
                                    >
                                        <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10 }} />
                                    </HtmlTooltip>
                                </p>
                            )}

                            {stakeData && (
                                <p> <strong style={{ color: "#119f24" }}>{beautifyNumber(dailyYield, 4)} OSCAR</strong>   Daily Yield
                                    &nbsp;
                                    <HtmlTooltip
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit">&nbsp;Daily Yield&nbsp;</Typography>
                                                <span>Estimated daily rewards based on your staked amount and current reward rate {stakeData.rewardRatePerEpoch}&nbsp;</span> <br />
                                            </React.Fragment>
                                        }
                                    >
                                        <HelpOutlineIcon style={{ width: 18, height: 18, marginBottom: 10 }} />
                                    </HtmlTooltip>
                                </p>
                            )}
                            {stakeData && userData && (
                                <TextField
                                    id="referral-link"
                                    label="Referral Link"
                                    variant="standard"
                                    InputProps={{
                                        style: {
                                            color: "inherit",
                                            borderColor: "inherit",  
                                        },
                                        sx: {
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "inherit",  
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "inherit",  
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "inherit",  
                                            },
                                        },
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: "inherit",
                                        },
                                    }}
                                    onChange={(e) => {
                                        handleSetReferrer(e.target.value);
                                    }} />
                            )}


                        </div>



                    </div>
                    <div className="right">
                        <form action="/wallet"
                            onSubmit={(e) => {
                                handleSubmit(e);
                            }}
                        >
                            <div className="form-group" style={{ position: 'relative', width: '100%', maxWidth: '400px', marginTop: 30 }}>

                                <input
                                    disabled={!userData || !stakeData || errorMessage.toString().includes("switch your network") ? true : false}
                                    type="number"
                                    placeholder="Enter amount"
                                    id="stakeAmount"
                                    value={amount == 0 ? "" : amount}
                                    onChange={(e) => {
                                        handleSetAmount(e.target.value);
                                        setErrorMessage("");
                                    }
                                    }
                                    onClick={() => {
                                        if (!address) {
                                            openConnectModal();
                                        }
                                    }}
                                />

                                <img
                                    src={oscarIcon}
                                    alt="OSCAR Icon"
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        width: '30px',
                                        height: '30px',
                                    }}
                                />
                                <button
                                    type="button"
                                    disabled={
                                        !userData
                                        || !stakeData ||
                                        (
                                            stakeButton.toString() != 'CONNECT WALLET'
                                            && stakeButton.toString() != 'STAKE'
                                        )
                                    }
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        backgroundColor: '#007BFF',
                                        color: '#fff',
                                        border: 'none',
                                        backgroundColor:"#119f24",
                                        borderRadius: '12px',
                                        padding: '5px 10px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        width: 50,
                                        marginRight: 10
                                    }}
                                    onClick={handleSetMaxAmount}
                                >
                                    MAX
                                </button>
                            </div>

                            <button
                                type="submit"
                                disabled={
                                    !stakeData ||
                                    (
                                        stakeButton.toString() != 'CONNECT WALLET'
                                        && stakeButton.toString() != 'STAKE'
                                    )
                                }
                                className="btn-action"
                                style={{
                                    width: '100%',
                                    backgroundColor:"#119f24",
                                    maxWidth: '390px',
                                    padding: '10px', 
                                    color: '#fff',
                                    cursor: 'pointer',
                                    marginRight: 150
                                }}
                            >
                                {stakeButton}
                            </button>
                        </form>
                    </div>
                </div>
                </div>
            )}

            <StakeInfo userData={userData} HtmlTooltip={HtmlTooltip} stakeData={stakeData} weeklyYield={weeklyYield}/>
       
        

        </>


    );

};

export default StakeForm;
